import React, { useEffect, useState } from "react";
import { Button, Space, Select } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import Event from "./Event";
import { useIntl } from "react-intl";
import { getFullName } from "../../../util/helpers";
import SchedulingTable from "./SchedulingTable";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { listEmployeeEffectiveOrders } from "../../../../api/server";
import { transferPeriod } from "../../../../features/employeeScheduling/schedulingSlice";
import { useDispatch } from "react-redux";
import moment from "moment";
const { Option } = Select;

const RecurrentEventsReplacements = (props) => {
  const {
    fromDate,
    toDate,
    activeEmployee,
    abscenceActions,
    triggerFetch,
    triggerQueryTimestamp,
  } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  let { branchId } = useParams();
  const [ordersList, setOrdersList] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [activeEvent, setActiveEvent] = useState({});
  const [mode, setMode] = useState(null);
  const [eventVisible, setEventVisible] = useState(false);
  const [recurrentEvents, setRecurrentEvents] = useState([]);

  const { isLoading, data } = useQuery(
    [branchId, activeEmployee, fromDate, toDate, triggerQueryTimestamp],
    async () => {
      const params = {
        current: 1,
        pageSize: 100,
        scopePrefix: branchId ? `branches/${branchId}/` : "",
        employeeId: activeEmployee.id,
        query: {
          from: fromDate,
          to: toDate,
        },
      };
      const result = await listEmployeeEffectiveOrders(params);
      return result.data;
    },
    {
      staleTime: 0,
      enabled:
        branchId !== null &&
        activeEmployee.id !== null &&
        activeEmployee.id !== undefined &&
        fromDate !== null &&
        toDate !== null,
    }
  );

  useEffect(() => {
    let orders = [];
    if (data && data.items && data.items.length > 0) {
      data.items.forEach((item, i) => {
        if (
          item.recurrent_work_events &&
          item.recurrent_work_events.length > 0
        ) {
          const total =
            Math.round(
              (item.recurrent_work_events.reduce(
                (a, b) => +a + +b.duration_minutes,
                0
              ) /
                60) *
                100
            ) / 100;
          const name = `${getFullName(
            item.patient.surename,
            item.patient.first_name
          )} - ${item.client.name} (${total})`;
          orders.push({ name, id: item.id });
        }
      });
    }
    setOrdersList(orders);
    if (orders && orders.length > 0 && !selectedOrder) {
      setSelectedOrder(orders[0].id);
    }
  }, [data]);

  useEffect(() => {
    let events = [];
    if (data && data.items && data.items.length > 0 && selectedOrder) {
      const selected = data.items.filter((i) => i.id === selectedOrder)[0];
      events = selected.recurrent_work_events.map((item) => {
        var startOfWeek = moment().startOf("week");
        const day = startOfWeek.add(item.weekday, "days");
        const startDate = day.set("minute", item.start_time_minutes);
        const start = startDate.toDate();
        const end = startDate.add(item.duration_minutes, "minutes").toDate();
        return {
          ...item,
          patient: {
            ...selected.patient,
            care_demands:
              (selected.patient.care_demands &&
                selected.patient.care_demands.map((i) => i.id)) ||
              [],
          },
          order: { id: selected.id, client: selected.client },
          employee: activeEmployee,
          order_id: selected.id,
          start,
          end,
        };
      });
    }
    setRecurrentEvents(events.sort((a, b) => a.start - b.start));
  }, [data, selectedOrder, activeEmployee]);

  const onOrderChange = (order) => {
    setSelectedOrder(order);
  };

  const onAddSchedulingClick = () => {
    const newId = recurrentEvents.reduce((a, b) => 1 + a + b.id, 0);
    const selected = data.items.filter((i) => i.id === selectedOrder)[0];
    const newEvent = {
      id: newId,
      patient: {
        ...selected.patient,
        care_demands:
          (selected.patient.care_demands &&
            selected.patient.care_demands.map((i) => i.id)) ||
          [],
      },
      order: { id: selected.id, client: selected.client },
      order_id: selected.id,
      newReplacement: true,
    };
    setActiveEvent(newEvent);
    setMode("new");
    setEventVisible(true);
  };

  const onDelete = (record) => {
    setRecurrentEvents(recurrentEvents.filter((i) => i.id !== record.id));
    setEventVisible(false);
    setActiveEvent({});
    setMode(null);
  };

  const onEdit = (record) => {
    setActiveEvent(record);
    setEventVisible(true);
    setMode("edit");
  };
  const submitEvent = (temporaryActiveEvent) => {
    let duplicatedEvents = [];
    if (
      temporaryActiveEvent.duplicateWeekdays &&
      temporaryActiveEvent.duplicateWeekdays.length > 0
    ) {
      temporaryActiveEvent.duplicateWeekdays.forEach((item, i) => {
        if (item !== temporaryActiveEvent.weekday) {
          var duration = moment.duration(
            moment(temporaryActiveEvent.end).diff(
              moment(temporaryActiveEvent.start)
            )
          );
          var minutesDuration = duration.asMinutes();
          const minutes = moment(temporaryActiveEvent.start).minutes();
          const hours = moment(temporaryActiveEvent.start).hours();
          let start = moment().startOf("week");
          start.add(item, "days");
          start.add(hours, "hours");
          start.add(minutes, "minutes");
          let end = start;
          end.add(minutesDuration, "minutes");
          const temp = {
            ...temporaryActiveEvent,
            id: temporaryActiveEvent.id + 1 + item,
            duplicated: true,
            weekday: item,
            replacement: true,
            duplicateWeekdays: null,
            start: start.toDate(),
            end: end.toDate(),
          };
          duplicatedEvents.push(temp);
        }
      });
    }
    const filtered = [...recurrentEvents].filter(
      (i) => +i.id !== +temporaryActiveEvent.id
    );
    const updated = [
      ...filtered,
      ...duplicatedEvents,
      { ...temporaryActiveEvent, replacement: true, duplicateWeekdays: null },
    ];
    setRecurrentEvents(updated.sort((a, b) => a.start - b.start));
    setEventVisible(false);
  };

  const cancelEvent = () => {
    setEventVisible(false);
    setActiveEvent({});
    setMode(null);
  };

  const onGenerateScheduling = async () => {
    const params = {
      order_id: selectedOrder,
      generated_from: fromDate,
      generated_until: toDate,
      recurrent_events: recurrentEvents,
      employeeId: activeEmployee.id,
    };
    const action = await dispatch(transferPeriod(params));
    if (!action.error) {
      triggerFetch(moment().format());
    }
  };

  return (
    <div style={{ marginTop: "10px" }}>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "10px",
          }}
        >
          <Space direction="horizontal">
            <Select
              style={{ width: "300px" }}
              showSearch
              placeholder={intl.formatMessage({
                id: "app.employees.selectOrder",
              })}
              optionFilterProp="children"
              onChange={onOrderChange}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              value={selectedOrder}
              allowClear
              disabled={!fromDate || !toDate}
            >
              {ordersList
                ? ordersList.map((b) => (
                    <Option value={b.id} key={b.id}>
                      {b.name}
                    </Option>
                  ))
                : null}
            </Select>
          </Space>
          <Space direction="horizontal">
            <Button
              style={{}}
              type="primary"
              onClick={onAddSchedulingClick}
              size="normal"
              disabled={!selectedOrder}
            >
              <PlusOutlined />
              {intl.formatMessage({
                id: "app.actions.addScheduling",
              })}
            </Button>
          </Space>
        </div>

        <SchedulingTable
          data={recurrentEvents}
          onDelete={onDelete}
          onEdit={onEdit}
          loading={isLoading}
        />
      </div>
      <div
        style={{
          paddingTop: "10px",
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Button
          style={{}}
          type="primary"
          onClick={onGenerateScheduling}
          disabled={!recurrentEvents || recurrentEvents.length === 0}
        >
          {intl.formatMessage({
            id: "app.actions.generateScheduling",
          })}
        </Button>
        {abscenceActions}
      </div>
      <Event
        activeEvent={activeEvent}
        removeEvent={onDelete}
        // editEvent={onEdit}
        visible={eventVisible}
        submit={submitEvent}
        cancel={cancelEvent}
        mode={mode}
      />
    </div>
  );
};

export default RecurrentEventsReplacements;
